import getLabelFromUnderscoreString from '../domains/Content/utils/getLabelFromUnderscoreString';



const getSelectValues = (imageTypes = []) => imageTypes.map((item) => {
  return {
    label: getLabelFromUnderscoreString(item),
    value: item,
  };
});


export default getSelectValues;
